import { useEffect } from "react";
import type { RefObject } from "react";
import styles from "./UploadView.module.css";

interface SuccessPopupProps {
  readonly dialogRef: RefObject<HTMLDialogElement>;
  readonly onOk: () => void;
}

export function SuccessPopup({ dialogRef, onOk }: SuccessPopupProps) {
  useEffect(() => {
    const dialog = dialogRef.current;
    if (dialog && !dialog.open) {
      dialog.showModal();
    }
  }, [dialogRef]);

  return (
    <dialog ref={dialogRef} className={styles.popupOverlay} aria-labelledby="docuparser-success-title" aria-modal="true">
      <div className={styles.popupModal}>
        <div className={styles.popupIcon} aria-hidden="true">
          <svg width="40" height="40" viewBox="0 0 62 62" fill="none">
            <circle cx="30" cy="30" r="30" fill="#4caf50" />
            <path d="M20 32L28 40L44 24" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h3 id="docuparser-success-title" className={styles.popupTitle}>
          Upload Successful!
        </h3>
        <p className={styles.popupMessage}>Your document has been successfully uploaded.</p>
        <div className={styles.popupButtons}>
          <button
            type="button"
            className={styles.popupBtnOk}
            onClick={onOk}
            aria-label="Close success message and return to document list"
          >
            OK
          </button>
        </div>
      </div>
    </dialog>
  );
}
